export const SET_DYNAMIC_JSON = 'SET_DYNAMIC_JSON';
export const SET_DYNAMIC_JSON_VALUES = 'SET_DYNAMIC_JSON_VALUES';
export const SET_DYNAMIC_JSON_TYPE = 'SET_DYNAMIC_JSON_TYPE';
export const SET_DYNAMIC_JSON_MODULE_NAME = 'SET_DYNAMIC_JSON_MODULE_NAME';
export const RELOAD_FIELD_OPTIONS_LIST = 'RELOAD_FIELD_OPTIONS_LIST';